import withEditarHonorarios from "../../hoc/Docentes/withEditarHonorarios";
import EditarHonorarios from "../../view/components/RegistroUsuarios/Honorarios/EditarHonorarios";

export default withEditarHonorarios(EditarHonorarios);